function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "16",
  viewBox: "0 0 12 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-401-301H623v2000H-401z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.25 4H9v-.8C9 1.433 7.657 0 6 0S3 1.433 3 3.2V4H.75C.336 4 0 4.358 0 4.8v8.8C0 14.925 1.007 16 2.25 16h7.5c1.243 0 2.25-1.075 2.25-2.4V4.8c0-.442-.336-.8-.75-.8zM4.5 3.2c0-.884.672-1.6 1.5-1.6s1.5.716 1.5 1.6V4h-3v-.8z",
  fill: "#F06046"
}))));